import { useCallback, useEffect, useRef, useState } from "react";

//https://groups.google.com/a/chromium.org/g/blink-dev/c/z6ienONUb5A/m/F5-VcUZtBAAJ
//TODO: refactor to use single instance?
const useResizeObserver = () => {
  const elementRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);

  const resizeObserverCallback = useCallback(
    (entryList: ResizeObserverEntry[]) => {
      if (entryList.length === 1) {
        const entry = entryList[0];
        setWidth(entry.contentRect.width);
        setHeight(entry.contentRect.height);
      }
    },
    [],
  );

  useEffect(() => {
    if (elementRef.current == null) return () => {};
    const resizeObserver = new ResizeObserver(resizeObserverCallback);
    resizeObserver.observe(elementRef.current);
    return () => {
      resizeObserver.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementRef.current, resizeObserverCallback]);

  return {
    elementRef,
    height,
    width,
  };
};

export default useResizeObserver;
